document.addEventListener('click', function(e) {
	let prevActive = document.querySelector('.product-gallery-item.--active');
	let ctx        = document.querySelector('.product-gallery ul');

	if (e.target.closest('.product-gallery-item')) {
		e.preventDefault();

		let currentClicked = e.target.closest('.product-gallery-item');
		let index          = Array.from(ctx.children).indexOf(currentClicked);
		let cssClass       = (index != 3) ? '--overflow-right' : '--overflow-left';

		if (currentClicked.classList.contains('--active')) {
			currentClicked.classList.remove('--active');
			ctx.classList.remove('--overflow-left', '--overflow-right');
		}
		else {
			if (prevActive != null) {
				ctx.classList.remove('--overflow-left', '--overflow-right');
				prevActive.classList.remove('--active');
			}
		
			currentClicked.classList.add('--active');
			ctx.classList.add(cssClass);
		}
	}
	else {
		if (prevActive != null) {
			ctx.classList.remove('--overflow-left', '--overflow-right');
			prevActive.classList.remove('--active');
		}
	}
});

document.querySelectorAll('.product-versions a.button').forEach( (elem) => {
	elem.addEventListener('click', e => {
		if (e.target.closest('.button')) {
			if (!e.target.closest('.model-preview').classList.contains('--active')) {
				// resets model selector
				if (document.querySelector('.product-versions.--selection') != null)
					document.querySelector('.product-versions.--selection').classList.remove('--selection');
				
				if (document.querySelector('.model-preview.--active') != null)
					document.querySelector('.model-preview.--active').classList.remove('--active');

				const modelRef = e.target.closest('.button').dataset.modelRef;
				const prevTab  = document.querySelector('.specs-tab.--active');
				const newTab   = document.querySelector('[data-model="' + modelRef + '"]')
				
				if (prevTab != null) {
					closeSpecsTab(
						prevTab,
						() => {
							prevTab.classList.remove('--active');	
						
							openSpecsTab(
								newTab,
								() => {
									newTab.classList.add('--active');
									document.querySelector('.specs-tab').scrollIntoView({ behavior: "smooth" });
								}
							);
						}
					);
				}
				else {
					openSpecsTab(
						newTab,
						() => {
							newTab.classList.add('--active');
							document.querySelector('.specs-tab').scrollIntoView({ behavior: "smooth" });
						}
					);
				}

				// sets new selector classes
				e.target.closest('.product-versions').classList.add('--selection');
				e.target.closest('.model-preview').classList.add('--active');

				// uopdates scrollTrigger for footer
				sleep(500).then(() => {
					ScrollTrigger.refresh();
					console.log('Refresh scrollTrigger');
				});
			}
		}
	});
});

function openSpecsTab(tab, onComplete) {
	gsap.to(tab, {
		duration: .4,
		height: 'auto',
		autoAlpha: 1,
		ease: "power4.inOut",
		onComplete: onComplete
	});
}

function closeSpecsTab(tab, onComplete) {
	gsap.to(tab, {
		duration: .4,
		height: 0,
		autoAlpha: 0,
		ease: "power4.inOut",
		onComplete: onComplete
	});
}

document.addEventListener('DOMContentLoaded', function() {
	document.querySelectorAll('.specs-tab').forEach( item => {
		let maxH = Math.max(item.querySelector('img').clientHeight, item.querySelector('.table-wrapper ').clientHeight);
		item.dataset.maxHeight = maxH;
	});

	document.querySelectorAll('.specs-tab .downloads .button').forEach( item => {
		item.addEventListener('click', (e) => {
			let ctx        = e.target.closest('.downloads');
			let targetList = e.target.dataset.target;

			if (targetList) {
				ctx.querySelectorAll('.--active').forEach((i) => {
					i.classList.remove('--active')
				});
				
				let prevList = ctx.querySelector('.file-list.--visible');

				if (prevList)
					prevList.classList.remove('--visible');

				e.target.classList.add('--active');

				let targetElem = ctx.querySelector("."  + targetList);

				targetElem.classList.add('--active');
				
				setTimeout(() => {
					targetElem.classList.add('--visible');
				}, 100);
			}
		});
	});
});
